<template>
  <div>
    <div class="box info-box">
        <div class="box-header with-border">
            <h3 class="box-title">Recent Members</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Cust Name</th>
                <th class="hidden-xs">Cust Code</th>
                <th>Mobile</th>
                <th class="hidden-xs">Address</th>
                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ index + 1 }}</td>
                <td v-if="row.user">{{ row.user.name }}</td>
                <td v-if="row.user" class="hidden-xs">{{ row.user.code }}</td>
                <td v-if="row.user">{{ row.user.mobile }}</td>
                <td class="hidden-xs" v-if="row.user">{{ row.address }}</td>
              </tr>
            </tbody>
          </table>
                
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'my-component',
  computed: {
    ...mapState([
      'profile',
      'user'
    ])
  },
  data () {
    return {
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    loadData () {
      var c = JSON.parse(localStorage.user)
      var userWise = ''
      if (c.role.name === 'Admin') {
        userWise = ''
      } else if (c.role.name === 'Manager') {
        userWise = `&branch_id=${c.agent_profile.branch_id}`
      } else {
        userWise = `&agent_id=${c.id}&branch_id=${c.agent_profile.branch_id}`
      }
      this.$axios.get('member?per_page=5' + userWise, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.rows = data.data
        // _.forEach(this.rows, function (item, key) {
        //   this.rows[key].name = item.user.name + ' (' + item.user.code + ')'
        // }.bind(this))
      })
      .catch(function (error) { console.log(error) })
    }
  },
  created () {
    this.loadData()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// recentmember.vue?5b5b8b10